import { ConfirmationData } from "../../../../common/summary-common/confirmationData";

const currentYear = new Date().getFullYear();
const previousYear = currentYear - 1;
const yearBeforePrevious = currentYear - 2;

export const overWriteFinancialInformation: Map<string, ConfirmationData> = new Map([
    ["10f45d2d-c889-4acf-8a8a-64e3255589b8", { hidden: true }],
    ["303d8815-9cfa-4be5-9cd5-5086b1328f3f", { hidden: true }],
    ["413ca9cb-58cf-4715-8628-6a9660e5104a|dda0e8b2-057c-4a3e-9c19-b9a57bc667ad", { showBorder: false }],
    ["cfeae1ca-6fce-4781-a5bb-9f8b160576a4|dda0e8b2-057c-4a3e-9c19-b9a57bc667ad", { showBorder: false }],
    ["7f8edecf-2efd-4af9-916c-8191c23acd42|45164ce8-b0cb-4310-a3ea-e0f141536e1c", { label: "Sí/No" }],
    ["04f6c622-6787-4f3a-87a9-fdd9fb7d8f64|ff1d86d7-e5b0-4e40-ac24-7327d6c1404f", { label: `Ingreso Anual ${previousYear}` }],
    ["04f6c622-6787-4f3a-87a9-fdd9fb7d8f64|556bfe93-17ee-453b-bb3f-fcb706251fec", { label: `Ingreso Anual ${yearBeforePrevious}` }],
]); 